import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ReactImages from 'react-images'

import Icon from 'Pods/Shared/Icon/Icon'

import { LessThanBreakpoint } from 'Utils/GetBreakpoint'

import processingImage from 'images/image_processing.png'

class Gallery extends React.Component {
  constructor() {
    super()
    this.state = {
      currentImage: 0,
      inline: true,
      isResponsive: true, // works nicer this way with SSR
      cdnHost: typeof window !== 'undefined' ? window.App.config.cdnHosts[0] : '',
    }
  }

  componentDidMount() {
    this.updateLayout()
    window.addEventListener('resize', this.updateLayout)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateLayout)
  }

  updateLayout = () => {
    this.setState({ isResponsive: LessThanBreakpoint('md') })
  }

  handleClose = () => {
    this.setState({ inline: true })
  }

  handleClickThumbnail = (index) => {
    this.setState({ currentImage: index })
  }

  handeClickNext = () => {
    this.setState(({ currentImage }) => ({ currentImage: currentImage + 1 }))
  }

  handleClickPrev = () => {
    this.setState(({ currentImage }) => ({ currentImage: currentImage - 1 }))
  }

  handleToggleFullscreenClick = () => {
    this.setState({ inline: false })
  }

  renderInstructions(images) {
    return (
      <Fragment>
        <div className="overflow-gallery__download">
          {
            !!images[this.state.currentImage].src
            && (
            <a href={images[this.state.currentImage].src} target="_blank" download className="link link--white">
              <Icon type={['fal', 'download']} /> Download original
            </a>
            )
          }
        </div>
        <div className="overflow-gallery__nav-info">
          Use <span className="overflow-gallery__key"><Icon type={['far', 'arrow-left']} notSpaced /></span>
          <span className="overflow-gallery__key"><Icon type={['far', 'arrow-right']} notSpaced /></span> to navigate. Press
          <span className="overflow-gallery__key">esc</span> to quit
        </div>
      </Fragment>
    )
  }

  render() {
    const { adultContentHTML, title } = this.props
    const images = this.props.images.map((item, index) => {
      const image = item.image_name || item.image
      const imageThumb = item.image_name_thumb
      const useCustom = adultContentHTML && item.adult

      return {
        src: (useCustom ? '' : image) || processingImage,
        alt: index === 0 ? title : '',
        thumbnail: useCustom ? '' : imageThumb,
        type: item.type,
        external_id: item.external_id,
        file_url: item.file_url,
        custom: useCustom,
      }
    })

    const showThumbnails = !this.state.inline || !this.state.isResponsive

    return (
      <Fragment>
        <ReactImages
          className="gallery-container"
          currentImage={this.state.currentImage}
          images={images}
          inline={this.state.inline}
          backdropClosesModal={false}
          isOpen
          showThumbnails={showThumbnails}
          showToggleFullscreen={showThumbnails}
          onClose={this.handleClose}
          onClickThumbnail={this.handleClickThumbnail}
          onClickNext={this.handeClickNext}
          onClickPrev={this.handleClickPrev}
          onToggleFullscreenClick={this.handleToggleFullscreenClick}
          customContent={() => {
            return <div dangerouslySetInnerHTML={{ __html: adultContentHTML }} style={{ width: '100%', height: '100%' }} />
          }}
          customThumbnailContent={() => {
            return <div className="parental-lock--gallery-small"><div className="parental-lock__title">Adult content</div></div>
          }}
          theme={{
            thumbnail: {
              size: 105,
              height: 75,
              gutter: 8,
            },
          }}
        />
        {!this.state.inline && this.renderInstructions(images)}
      </Fragment>
    )
  }
}

Gallery.propTypes = {
  images: PropTypes.array.isRequired,
}

export default Gallery
